import styled, { css } from 'styled-components';

export const StyledKakarikoPagination = styled.section`
  ${(props: { theme: any }) => {
    return css`
      &.pagination-bar {
        align-items: center;
        background: #fff;
        background: var(--white-full);
        display: flex;
        justify-content: left;
        max-width: 100vw;
        padding-left: 10px;
        height: 50px;
        width: 100%;

        .pagination {
          &-page {
            color: ${props.theme.defaultBase};
            color: var(--default-base);
            font-size: 14px;
            line-height: 18px;
            min-width: 80px;
          }

          &-navigation {
            align-items: center;
            display: -ms-flexbox;
            display: grid;
            grid-gap: 20px;
            grid-template-columns: repeat(5, auto);
            margin: 7px 10px;
            padding-left: 10px;

            &__page-size {
              .MuiInputBase-root {
                font-size: 0.8rem;
              }

              label {
                height: 0;
                visibility: hidden;
                width: 0;
              }
            }
          }

          &-icon {
            background: inherit;
            border: 0;
            cursor: pointer;
            height: 24px;
            padding: 0;
            width: 24px;
          }
        }
      }
    `;
  }}
`;
